import {
  Box,
  Button,
  SpeedDial,
  SpeedDialIcon,
  Typography,
  useMediaQuery,
  useTheme,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import styles from "../../content/pages/homepage.module.css";
import { useContext, useEffect, useRef, useState } from "react";
import { WidgetContext } from "src/contexts/WidgetContext";
import { isUnsyncedPlatform } from "src/constants/unsyncedLeague";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PlatformLogo from "./PlatformLogo";

const PlatformSelector = ({
  leaguePlatforms,
  expanded,
  handlePlatformSelectClick,
  handleIconClick,
  handlePlatformDeleteClick,
  setDeletionMode,
  setShakingPlatform,
  deletionMode,
  shakingPlatform,
  handlePlatformLongPress,
  isChangingPlatform,
  setIsChangingPlatform,
}) => {
  //state to disable the button when its change platform yahoo for another one
  const [loadingPlatform, setLoadingPlatform] = useState<string | null>(null);
  // Pending platform id when user taps X — confirm before calling handlePlatformDeleteClick
  const [pendingDeletePlatformId, setPendingDeletePlatformId] = useState<string | null>(null);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [isBoxDisabled, setIsBoxDisabled] = useState(true);
  const { allowedPlatforms } = useContext(WidgetContext);

  //State to get media query for mobile and tablet
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // // Add debounce function for the platform select click
  // const debounce = (func: Function, wait: number) => {
  //   // Debounce function to prevent multiple clicks on the platform select button
  //   let timeout: NodeJS.Timeout;
  //   // Return a function that will execute the original function after the delay
  //   return function executedFunction(...args: any[]) {
  //     // Clear the timeout if it exists
  //     const later = () => {
  //       // Clear the timeout
  //       clearTimeout(timeout);
  //       // validate if the platform is the same
  //       const [platformId] = args;
  //       // get the current platform
  //       const currentPlatform = leaguePlatforms.find((p) => p.isSelected)?.id;
  //       // if the platform is the same, execute the original function
  //       if (currentPlatform !== platformId) {
  //         func(...args);
  //       }
  //     };
  //     // Clear the timeout
  //     clearTimeout(timeout);
  //     // Set a new timeout to execute the original function after the delay
  //     timeout = setTimeout(later, wait);
  //   };
  // };

  // // Debounce the platform select click
  // const debouncedPlatformSelect = debounce(async (platformId: string) => {
  //   const currentPlatform = leaguePlatforms.find((p) => p.id === platformId);

  //   // Execute the original function
  //   if (currentPlatform) {
  //     setLoadingPlatform(platformId); // Show loader on the selected platform
  //     await new Promise((resolve) => setTimeout(resolve, 1000)); // 0.8 seconds of delay
  //     setLoadingPlatform(null);
  //   }
  //   handlePlatformSelectClick(platformId);
  // }, 500); // 500ms delay

  //function wraper to avoid issue with the teams of yahoo in other plataforms
  const handlePlatformSelectClickWrapper = async (platformId: string) => {
    // check if the platform is already selected
    const isAlreadySelected = leaguePlatforms.find((p) => p.id === platformId && p.isSelected);
    // if the platform is already selected, do nothing to avoid unnecessary requests
    if (isAlreadySelected) {
      // setIsChangingPlatform(false);
      return;
    }

    const currentPlatform = leaguePlatforms.find((p) => p.id === platformId);
    // If we come from Yahoo, add a delay
    // if (currentPlatform) {
    setLoadingPlatform(platformId); // Show loader on the selected platform
    await new Promise((resolve) => setTimeout(resolve, 1000)); // 1 seconds of delay
    setLoadingPlatform(null);
    // }
    // Call the original function
    handlePlatformSelectClick(platformId);
  };

  // Effect to handle Yahoo external login completion
  useEffect(() => {
    // if (yahooFinish) {
    setIsBoxDisabled(true);
    const timer = setTimeout(() => {
      setIsBoxDisabled(false);
    }, 2000);

    return () => clearTimeout(timer);
    // }
  }, []); // Run once on mount for yahooFinish

  const pendingDeletePlatform = pendingDeletePlatformId
    ? leaguePlatforms.find((p) => p.id === pendingDeletePlatformId)
    : undefined;
  const pendingDeletePlatformName = pendingDeletePlatform?.name ?? pendingDeletePlatformId ?? "";

  const handleCancelDisconnectDialog = () => {
    setPendingDeletePlatformId(null);
    setDeletionMode(null);
    setShakingPlatform(null);
  };

  const handleConfirmDisconnectPlatform = async () => {
    if (!pendingDeletePlatformId) return;
    const platformId = pendingDeletePlatformId;
    setPendingDeletePlatformId(null);
    setDeletionMode(null);
    setShakingPlatform(null);
    await handlePlatformDeleteClick(platformId);
  };

  const selectedPlatformId = leaguePlatforms.find((p) => p.isSelected)?.id;
  const platformPickerButtonLabel = isUnsyncedPlatform(selectedPlatformId) ? "Sync League" : "Leagues";

  return (
    <>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-evenly"
        sx={{
          bgcolor: "#222222",
          width: "100%",
          // borderBottom: "1px solid #555555",
        }}
      >
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          className="platforms-scroll-container"
          sx={{
            maxWidth: "calc(100% - 100px)", // room for Sync League button (+ padding/shadow)
            overflowX: "auto",
            gap: 0,
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            "& > button": {
              marginRight: 0,
              "&:last-child": {
                marginRight: 0,
              },
            },
            whiteSpace: "nowrap",
            flex: "1 0 auto",
          }}
        >
          {/* UI refactor: only the SELECTED platform tab (clicking connected cards in PlatformDropdown sets isSelected).
              Previous: all logged-in platforms as tabs — kept in comment below for rollback. */}
          {/* show only the allowed platforms (front and poc decided which platforms are allowed) */}
          {/* Un-Synced always visible when logged-in (bypass allowedPlatforms whitelist) */}
          {/* OLD multi-tab filter:
            .filter((p) => p.isLoggedIn && (isUnsyncedPlatform(p.id) || allowedPlatforms.includes(p.id)))
          */}
          {allowedPlatforms &&
            leaguePlatforms
              .filter(
                (p) =>
                  p.isSelected &&
                  (isUnsyncedPlatform(p.id) || allowedPlatforms.includes(p.id) || p.isLoggedIn),
              )
              .map((platform) => (
                <Button
                  key={platform.id}
                  data-platform-id={platform.id}
                  variant="text"
                  color="info"
                  sx={{
                    p: 0,
                    px: 1,
                    flexShrink: 0,
                    position: "relative",
                    borderRadius: 0,
                    borderBottom: "1px solid",
                    borderBottomColor: platform.isSelected ? "#ff672d" : "#555555",
                  }}
                  // OLD: long-press to shake + show delete X on PlatformSelector tabs
                  // {...(isUnsyncedPlatform(platform.id) ? {} : handlePlatformLongPress(platform.id))}
                  disabled={loadingPlatform === platform.id || isBoxDisabled}
                >
                  {/* {platform.isSelected && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        height: "1px",
                        backgroundColor: "#ff672d",
                        pointerEvents: "none",
                      }}
                    />
                  )} */}
                  {/* OLD: delete X on PlatformSelector tab (now lives on PlatformDropdown cards)
                  <Box
                    component="span"
                    sx={{
                      position: "absolute",
                      top: 0.5,
                      right: 0.5,
                      backgroundColor: "#ffffff",
                      borderRadius: "50%",
                      width: 14,
                      height: 14,
                      display: deletionMode === platform.id ? "flex" : "none",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      zIndex: 1,
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setPendingDeletePlatformId(platform.id);
                    }}
                  >
                    <CloseIcon
                      sx={{
                        fontSize: "14px",
                        color: "#000000",
                        // backgroundColor: "#ffffff",
                      }}
                    />
                  </Box>
                  */}
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    color={platform.isSelected ? "#ff672d" : "#343a40"}
                    sx={{ px: 0 }}
                  >
                    <Box
                      component="div"
                      key={platform.id}
                      onContextMenu={(e) => e.preventDefault()}
                      onClick={(e) => {
                        e.stopPropagation();
                        // If there is a shake effect on another platform, stop it
                        if (shakingPlatform && shakingPlatform !== platform.id) {
                          setShakingPlatform(null);
                          setDeletionMode(null);
                        }
                        // debouncedPlatformSelect(platform.id);
                        // handlePlatformSelectClick(platform.id);
                        handlePlatformSelectClickWrapper(platform.id);
                      }}
                      className={`${shakingPlatform === platform.id ? styles.platformShaking : ""}`}
                      sx={{
                        // width: "60px",
                        // width: "45px",
                        // height: "60px",
                        height: "40px",
                        // aspectRatio: "1/1",
                        // objectFit: "contain",
                        backgroundColor: "transparent",
                        borderRadius: 0.5,

                        // mixBlendMode: platform.isSelected ? "normal" : "multiply",
                        // padding: "15px",
                        position: "relative",
                        WebkitTouchCallout: "none", // Prevent context menu on iOS
                        WebkitUserSelect: "none", // Prevent selection on Safari
                        userSelect: "none", // Prevent selection on other browsers
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",

                        // backgroundImage:
                        //   loadingPlatform === platform.id
                        //     ? "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTQiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI0ZGNjcyRCIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtZGFzaGFycmF5PSI4MCIgc3Ryb2tlLWRhc2hvZmZzZXQ9IjYwIj48YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgZnJvbT0iMCAxNiAxNiIgdG89IjM2MCAxNiAxNiIgZHVyPSIwLjhzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIvPjwvY2lyY2xlPjwvc3ZnPg==')"
                        //     : `url(${platform.img})`,
                        // // `url(${platform.img})`,
                        // backgroundSize:
                        //   loadingPlatform === platform.id
                        //     ? "60%" // size of the loader
                        //     // : platform.name === "Sleeper"
                        //     //   ? "45%"
                        //     //   : platform.name === "MFL"
                        //     //     ? "65%"
                        //     //     : platform.name === "FleaFlicker"
                        //     //       ? "60%"
                        //     //       : platform.name === "Yahoo"
                        //     //         ? "65%"
                        //     : "100%",
                        // backgroundPosition: "center",
                        // backgroundRepeat: "no-repeat",

                      }}
                    >
                      {/* show the name if is unsynce */}
                      {isUnsyncedPlatform(platform.id) ? (
                        <Typography
                          variant="h3"
                          sx={{
                            fontSize: "14px",
                            color: platform.isSelected ? "#ff672d" : "#555555",
                            fontWeight: "bold",
                            width: "100px"
                            // visibility: loadingPlatform === platform.id ? "hidden" : "visible",
                            // visibility: "hidden",
                          }}
                        >
                          {platform.name}
                        </Typography>
                      ) : (
                        <PlatformLogo
                          platformId={platform.id}
                          platformName={platform.name}
                          img={platform.img}
                          variant="selector"
                        />
                      )}
                      {loadingPlatform === platform.id && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <CircularProgress size={24} sx={{ color: "#ff672d" }} />
                        </Box>
                      )}
                    </Box>

                    {/* <Typography variant="body2" color={`${PureLightThemeCaaS.colors.alpha.white[100]}`} >  */}
                    {/* <Typography variant="body2" color={`${PureLightThemeCaaS.colors.alpha.white[100]}`} sx={{ fontSize: "10px", pt: 0.5 }}>
                      {platform.name}
                    </Typography> */}
                  </Box>
                </Button>
              ))}
        </Box>

        {/* Sync League replaces Connect A League + SpeedDial (kept below for reference) */}
        <Box
          sx={{
            bgcolor: "#000000",
            p: 0.5,
            pl: 0.2,
            pr: 0.2,
            flexShrink: 0,
            position: "relative",
            // Same left fade/shadow that sat beside the SpeedDial
            "&::before": {
              content: '""',
              position: "absolute",
              left: -40,
              top: 0,
              width: 50,
              height: "100%",
              background: "linear-gradient(to right, transparent, #000000)",
              pointerEvents: "none",
            },
          }}
        >
          <Button
            variant="contained"
            data-testid="open-platform-picker"
            onClick={handleIconClick}
            sx={{
              width: "110px",
              minHeight: "30px",
              py: 0.5,
              px: 1,
              bgcolor: "#FF672D",
              color: "#ffffff",
              fontWeight: 700,
              fontSize: "13px",
              textTransform: "none",
              borderRadius: "8px",
              boxShadow: "none",
              whiteSpace: "nowrap",
              "&:hover": {
                bgcolor: "#FF672D",
                boxShadow: "none",
              },
            }}
          >
            {platformPickerButtonLabel}
          </Button>
        </Box>

        {/* Same visibility rule as platform tabs: real + allowed + logged-in (ignore Un-Synced and ghost logged-in outside whitelist) */}
        {/* {(!allowedPlatforms ||
          !leaguePlatforms.some(
            (platform) =>
              platform.isLoggedIn &&
              !isUnsyncedPlatform(platform.id) &&
              allowedPlatforms.includes(platform.id),
          )) && (
            <Typography
              variant="h4"
              onClick={handleIconClick}
              sx={{
                position: "absolute",
                right: 0,
                pr: 3,
                // fontSize: isMobile ? "12px" : "15px",
                fontSize: "15px",
                fontWeight: 600,
                cursor: "pointer",
                WebkitTapHighlightColor: "transparent",
                userSelect: "none",
                display: "inline-flex",
                alignItems: "center",
                gap: 0.5,
              }}
              color={`${PureLightThemeCaaS.colors.alpha.white[100]}`}
            >
              Connect A League  <ArrowForwardIcon sx={{ fontSize: "14px" }} />
            </Typography>
          )}

        <Box
          sx={{
            bgcolor: "#000000",
            p: 0.6,
            // pt: 2.5,
            // pb: 2.5,
            // pt: 1.5,
            // pb: 1.5,
            pl: 0.5,
            flexShrink: 0,
            position: "relative",
            "&::before": {
              content: '""',
              position: "absolute",
              left: -40,
              top: 0,
              width: 50,
              height: "100%",
              background: "linear-gradient(to right, transparent, #000000)",
              pointerEvents: "none",
            },
          }}
        >
          <SpeedDial
            ariaLabel="SpeedDial example"
            icon={<SpeedDialIcon icon={<AddIcon />} openIcon={<CloseIcon />} />}
            onClick={handleIconClick}
            open={expanded === "panel0"}
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
            FabProps={{
              sx: {
                //comment this width and height to let 56 for default size
                width: "30px",
                height: "30px",
                minWidth: "30px",
                minHeight: "30px",
                bgcolor: "#FF672D",
                "&:hover": {
                  bgcolor: "#FF672D",
                },
              },
              // className: styles.speedDialNeumorphic,
              // size: "small",
            }}
          />
        </Box> */}
      </Box>

      <Dialog
        open={pendingDeletePlatformId !== null}
        onClose={handleCancelDisconnectDialog}
        maxWidth="xs"
        fullWidth
        sx={{
          zIndex: 1600,
        }}
        PaperProps={{
          sx: {
            bgcolor: "#EDEDED",
            borderRadius: 1,
            border: "0.5px solid #000000",
            boxShadow: "4px 4px 12px rgba(0,0,0,0.25)",
            p: 0.5,
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              position: "fixed",
              backdropFilter: "blur(1px) !important",
              WebkitBackdropFilter: "blur(1px) !important",
              backgroundColor: "rgba(0, 0, 0, 0.35)",
            },
          },
        }}
      >
        <DialogTitle sx={{ textAlign: "center", color: PureLightThemeCaaS.colors.alpha.black[100], fontWeight: 700, p: 1, pb: 0 }}>
          Are you sure you want to disconnect {pendingDeletePlatformName}?
        </DialogTitle>
        <DialogActions sx={{ justifyContent: "center", gap: 1 }}>
          <Button
            variant="contained"
            onClick={handleCancelDisconnectDialog}
            autoFocus
            sx={{
              flex: 1,
              whiteSpace: "nowrap",
              p: 0.5,
              bgcolor: PureLightThemeCaaS.colors.alpha.orange[100],
              "&:hover": { bgcolor: PureLightThemeCaaS.colors.alpha.orange[90] },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="outlined"
            onClick={() => void handleConfirmDisconnectPlatform()}
            sx={{
              flex: 1,
              whiteSpace: "nowrap",
              p: 0.5,
              borderColor: PureLightThemeCaaS.colors.alpha.black[70],
              color: PureLightThemeCaaS.colors.alpha.black[100],
              "&:hover": { borderColor: PureLightThemeCaaS.colors.alpha.black[100] },
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PlatformSelector;
